import * as React from "react";

;
export const XSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 10.94L6.53 5.47 5.47 6.53 10.94 12l-5.47 5.47 1.06 1.06L12 13.06l5.47 5.47 1.06-1.06L13.06 12l5.47-5.47-1.06-1.06L12 10.94z" fill="#100722" /></svg>;